import { Inject, NgZone, AfterViewInit, OnDestroy, Component, Input } from '@angular/core';
import { BuildingFloor, Property } from '../../../models/index';
import { MapPlanBase } from './map-plan-base.model';
import { LocaleService } from '../../../seo/locale.service';
import { ListTrackingService } from './../../../utils/list-tracking.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-map-plan-building-floor-base',
  templateUrl: './map-plan-building-floor-base.component.html'
})
export class MapPlanBuildingFloorBaseComponent extends MapPlanBase implements AfterViewInit, OnDestroy {
  @Input() buildingFloor: BuildingFloor;
  @Input() propertyToolTipText: (property: Property) => string;

  constructor(
    private localeService: LocaleService,
    public zone: NgZone,
    @Inject(DOCUMENT) private document: any,
    @Inject('WINDOW') public window: any,
    public listTrackingService: ListTrackingService
  ) {
    super(zone, window)
  }

  ngAfterViewInit(): void {
    this.runImgMappingScript();
  }

  ngOnDestroy(): void {
    this.removeImgMappingScript();
  }

  currentRoute(): string {
    return this.document.location.href;
  }

  propertyToolTip(property: Property): string {
    if (this.propertyToolTipText)
      return this.propertyToolTipText(property);
    return property.title + ' [ap: ' + property.number + ']<br>(' + this.propertyAvailability(property.availability) + ')';
  }

  propertyAvailability(availability: string): string {
    let translated = {};

    if (this.localeService.getCurrentLocale() === 'ro') {
      translated = {
        available: 'Disponibil',
        sold: 'Vândut',
        unavailable: 'Indisponibil',
        reserved: 'Rezervat'
      }
    } else if (this.localeService.getCurrentLocale() === 'en') {
      translated = {
        available: 'Available',
        sold: 'Sold',
        unavailable: 'Unavailable',
        reserved: 'Reserved'
      }
    } else {
      return availability;
    }

    return translated[availability];
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/map-plan/map-plan-building-floor-base.component.ts